<template>
  <aside class="app-sidebar">
    <router-link class="app-brand" :to="{ name: 'Homepage' }">
      <div class="logo"></div>
      <div class="brand-copy">
        <strong>Орёл Туристический</strong>
        <span>Панель управления</span>
      </div>
    </router-link>

    <nav class="app-navigation">
      <router-link
        v-for="route in routes"
        :key="route.routeName"
        class="app-nav-link"
        active-class="is-active"
        :to="{ name: route.routeName }"
      >
        <b-icon :icon="route.icon" />
        <span>{{ route.title }}</span>
      </router-link>
    </nav>

    <button type="button" class="logout-button" @click="logout">
      <b-icon icon="box-arrow-right" />
      <span>Выйти</span>
    </button>
  </aside>
</template>

<script>
import Vue from 'vue';
import { mapActions } from 'vuex';

export default Vue.extend({
  name: 'TopBar',
  data() {
    return {
      routes: [
        { title: 'Главная', routeName: 'Homepage', icon: 'house-door' },
        { title: 'Посетить', routeName: 'Places', icon: 'geo-alt' },
        { title: 'Отдых', routeName: 'PlacesTravel', icon: 'cup' },
        { title: 'Типы мест', routeName: 'PlaceTypes', icon: 'collection' },
        { title: 'Маршруты', routeName: 'Routes', icon: 'map' },
        { title: 'Авторы', routeName: 'Authors', icon: 'people' },
      ],
    };
  },
  methods: {
    ...mapActions('auth', ['ActionLogout']),
    async logout() {
      try {
        await this.ActionLogout();
      } catch (e) {
        this.$bvToast.toast(e.message, { variant: 'danger' });
      }
      this.$router.push({ name: 'Auth' });
    },
  },
});
</script>

<style lang="scss" scoped>
.app-sidebar {
  position: fixed;
  z-index: 100;
  top: 0;
  bottom: 0;
  left: 0;
  display: flex;
  width: 248px;
  flex-direction: column;
  padding: 24px 16px 18px;
  color: #fff;
  background: linear-gradient(180deg, #b70909 0%, #8f0808 100%);
  box-shadow: 8px 0 30px rgba(77, 4, 4, 0.15);
}

.app-brand {
  display: flex;
  align-items: center;
  margin: 0 6px 30px;
  color: #fff;

  &:hover {
    color: #fff;
    text-decoration: none;
  }
}

.logo {
  width: 46px;
  height: 46px;
  flex: 0 0 46px;
  background-image: url(../../assets/logo.png);
  background-position: center;
  background-size: cover;
  border: 2px solid rgba(255, 255, 255, 0.7);
  border-radius: 13px;
  box-shadow: 0 5px 14px rgba(64, 0, 0, 0.2);
}

.brand-copy {
  display: flex;
  min-width: 0;
  flex-direction: column;
  margin-left: 12px;

  strong {
    font-size: 15px;
    line-height: 1.25;
  }

  span {
    margin-top: 2px;
    color: rgba(255, 255, 255, 0.65);
    font-size: 11px;
  }
}

.app-navigation {
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 6px;
}

.app-nav-link,
.logout-button {
  display: flex;
  width: 100%;
  align-items: center;
  gap: 12px;
  padding: 11px 14px;
  color: rgba(255, 255, 255, 0.76);
  border: 0;
  border-radius: 10px;
  background: transparent;
  font-size: 14px;
  font-weight: 600;
  text-align: left;
  transition: color 0.15s ease, background-color 0.15s ease, transform 0.15s ease;

  .b-icon {
    width: 18px;
    height: 18px;
  }

  &:hover {
    color: #fff;
    background: rgba(255, 255, 255, 0.1);
    text-decoration: none;
    transform: translateX(2px);
  }
}

.app-nav-link.is-active {
  color: #a90a09;
  background: #fff;
  box-shadow: 0 7px 18px rgba(64, 0, 0, 0.16);
}

.logout-button {
  cursor: pointer;
}

@media (max-width: 1599.98px) and (min-width: 992px) {
  .app-sidebar {
    width: 216px;
    padding-right: 12px;
    padding-left: 12px;
  }

  .app-brand {
    margin-right: 4px;
    margin-left: 4px;
  }
}

@media (max-width: 991.98px) {
  .app-sidebar {
    width: 84px;
    padding: 22px 12px 16px;
  }

  .app-brand {
    justify-content: center;
    margin: 0 0 28px;
  }

  .brand-copy,
  .app-nav-link span,
  .logout-button span {
    display: none;
  }

  .app-nav-link,
  .logout-button {
    justify-content: center;
    padding: 13px;
  }
}
</style>
